import type { ReactNode } from 'react';

interface ViewHeaderProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  /** Negative-margin out of a horizontally-padded parent (e.g. journey-view). */
  bleed?: boolean;
  /** Optional pill overlapping the bottom-right of the icon badge (e.g. the
      app version on Home). */
  badge?: ReactNode;
  /** Optional control rendered on the right (e.g. the art-switcher chip).
      Must be a button (or contain one) — App.tsx's desktop drag handler
      exempts buttons inside .view-header. */
  action?: ReactNode;
  /** Extra class on the header, for a per-view variant (Home's lockup). */
  className?: string;
}

// Shared section header shown at the top of each main view (Series, Library,
// Discover): a gradient icon badge on the left with title + subtitle to the
// right, on a dark full-width band.
export default function ViewHeader({ icon, title, subtitle, bleed, action, badge, className }: ViewHeaderProps) {
  return (
    <header className={`view-header${bleed ? ' view-header--bleed' : ''}${className ? ` ${className}` : ''}`}>
      <div className="view-header-icon">
        {icon}
        {badge && <span className="view-header-badge">{badge}</span>}
      </div>
      <div className="view-header-text">
        <h2 className="view-header-title">{title}</h2>
        {subtitle && <p className="view-header-sub">{subtitle}</p>}
      </div>
      {action && <div className="view-header-action">{action}</div>}
    </header>
  );
}
